import { clients, getMountingSchedulerMenu, orders, shippingList, system, gallery, dashboard, drive } from './export';
import { NavItemType } from 'types/index.types';
import mountingOrders from './mountingOrders';

const getMenuItems = async () => {
    const items: NavItemType[] = [dashboard, orders, shippingList, mountingOrders, clients, gallery, drive, system];
    const mountingScheduler = await getMountingSchedulerMenu();
    items.splice(-4, 0, mountingScheduler);
    return { items };
};

export default getMenuItems;
